export default __webpack_public_path__ + "static/media/door-glass.6d44ce4e.jpg";